import React from "react";

function HeaderPage() {
  return (
    <>
      <style>{`
		.header {
		  background: linear-gradient(
		    270deg,
		    #ffe3e3,
		    #fff5f0,
		    #f3f0ff,
		    #e0f7fa,
		    #e8f5e9,
		    #fffde7,
		    #ffe3e3
		  );
		  background-size: 1000% 100%;

		  animation: smoothFlow 25s linear infinite;

		  padding: 10px 18px;
		  border-bottom: 3px solid #d32f2f;
		  font-family: 'Poppins', 'Segoe UI', sans-serif;
		  box-shadow: 0 3px 10px rgba(0,0,0,0.05);
		}

		/* 🔥 Key animation (IMPORTANT) */
		@keyframes smoothFlow {
		  0% {
		    background-position: 0% 50%;
		  }
		  100% {
		    background-position: 100% 50%;
		  }
		}
        .header-top {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .logo {
          width: 55px;
          height: 55px;
          border-radius: 6px;
          border: 1.5px solid #2f55d4;
          padding: 4px;
          background: #fff;
        }

        .title-section {
          flex: 1;
        }

		.main-title {
		  font-size: 20px;
		  font-weight: 700;
		  color: #1a237e;
		  margin: 0;

		  display: inline-block;

		  opacity: 0;
		  transform: translateX(100vw); /* 🔥 start fully off-screen */

		  animation: slideInFull 2s ease-out forwards;
		}

		/* 🔥 Animation */
		@keyframes slideInFull {
		  0% {
		    opacity: 0;
		    transform: translateX(100vw); /* outside screen */
		  }
		  70% {
		    opacity: 1;
		    transform: translateX(-15px); /* small overshoot (rocket feel 🚀) */
		  }
		  100% {
		    opacity: 1;
		    transform: translateX(0); /* final position */
		  }
		}

        .sub-title {
          font-size: 12px;
          color: #5f6f81;
          margin-top: 2px;
          line-height: 1.4;
        }

        .location-tag {
          display: inline-block;
          margin-top: 4px;
          background: #e8edff;
          color: #2f55d4;
          padding: 3px 10px;
          border-radius: 15px;
          font-size: 11px;
          font-weight: 600;
        }

        .header-line {
          margin-top: 8px;
          height: 3px;
          border-radius: 10px;
          background: linear-gradient(to right, #2f55d4, #ff9800);
        }

        .exam-text {
          margin-top: 6px;
          font-size: 12.5px;
          color: #2c3e50;
          line-height: 1.5;
        }

        .exam-text b {
          color: #2f55d4;
        }

        /* Responsive */
        @media (max-width: 600px) {
          .header-top {
            flex-direction: column;
            align-items: flex-start;
          }

          .logo {
            width: 45px;
            height: 45px;
          }

          .main-title {
            font-size: 15px;
          }

          .sub-title {
            font-size: 11px;
          }

          .exam-text {
            font-size: 11.5px;
          }
        }
      `}</style>

      <div className="header">
        <div className="header-top">

          <img
            src="/ASTU_JMEE_JLEE/img/astulogo.png"
            alt="logo"
            className="logo"
          />

          <div className="title-section">
            <h1 className="main-title">
              ASSAM SCIENCE AND TECHNOLOGY UNIVERSITY
            </h1>

            <div className="sub-title">
              A State University of Government of Assam constituted by 
              "Assam Science and Technology University Act, 2009"
            </div>

            <span className="location-tag">Assam, India</span>
          </div>
        </div>

        <div className="header-line"></div>

        <div className="exam-text">
          <b>JOINT MCA ENTRANCE EXAMINATION (JMEE)-2026</b> for admission into 1st Semester M.C.A Programme /
          <b> JOINT LATERAL ENTRY EXAMINATION (JLEE)-2026</b> for admission into 3rd semester of B.Tech. programme
        </div>
      </div>
    </>
  );
}

export default HeaderPage;